const stringToUrl = (str: string, delimiter = "-") =>
  str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, delimiter);

export default stringToUrl;
